/**
 * Sets a cookie.
 * @param {string} name - Name for the cookie.
 * @param {string} value - Value for the cookie.
 * @param {number} days - Number of days until the cookie should expire.
 */
function setCookie(name, value, days) {
  let expires = '';

  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = `; expires=${date.toUTCString()}`;
  }

  document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=/; SameSite=None; Secure`;
}

/**
 * Gets the value of a cookie (if it exists).
 * @param {string} name - Name of the cookie.
 * @returns {?string}
 */
function getCookie(name) {
  const cookieString = `; ${document.cookie}`;
  const cookies = cookieString.split(`; ${name}=`);

  if (cookies.length === 2) {
    return cookies.pop().split(';').shift();
  }

  return null;
}

/* global Modal */

if (!customElements.get('pop-up')) {
  customElements.whenDefined('modal-dialog').then(() => {
    class PopUp extends Modal {
      constructor() {
        super();
        this.cookie = `${this.id}-dismissed`;
        this.cancelled = false;

        // ECOREINA: si añade al carrito antes de que salte, se anula del todo.
        document.addEventListener('on:cart:add', () => { this.cancelled = true; });

        if (Shopify.designMode) {
          document.addEventListener('shopify:section:select', (evt) => {
            if (evt.target === this.closest('.shopify-section')) this.open();
          });

          document.addEventListener('shopify:section:deselect', this.close.bind(this));
        } else if (!getCookie(this.cookie) && (this.dataset.showOnMobile === 'true'
          || theme.mediaMatches.md)) {
          if (this.querySelector('.alert')) {
            this.open();
          } else if (this.dataset.trigger === 'delay') {
            setTimeout(() => this.requestOpen(), Number(this.dataset.delay) * 1000);
          } else if (this.dataset.trigger === 'exit' && theme.mediaMatches.md) {
            this.mouseLeaveHandler = this.mouseLeaveHandler || this.handleMouseLeave.bind(this);
            document.body.addEventListener('mouseleave', this.mouseLeaveHandler);
          }
        }
      }
      /* ------------------------------------------------------------------
       * ECOREINA 22/09/2026 — el popup no puede interrumpir una compra.
       * Se disparaba sobre el cajon del carrito abierto y dejaba el boton
       * PAGAR fisicamente inaccesible: un clic en su centro impactaba en
       * POP-UP.modal. Explicaba una tasa carrito->checkout del 16,5%.
       * ------------------------------------------------------------------ */

      /**
       * Hay un cajon lateral o cualquier otro modal abierto ahora mismo?
       * @returns {boolean}
       */
      static overlayOpen() {
        return !!document.querySelector(
          'cart-drawer[open], side-drawer[open], modal-dialog[open], .js-cart-drawer[open]'
        );
      }

      /**
       * El carrito tiene productos? Se consulta en vivo para no depender del
       * HTML renderizado en servidor, que puede venir cacheado.
       * @returns {Promise<boolean>}
       */
      static async cartHasItems() {
        try {
          const base = (window.theme && theme.routes && theme.routes.cart) || '/cart';
          const res = await fetch(`${base}.js`, { headers: { Accept: 'application/json' } });
          if (!res.ok) return false;
          const cart = await res.json();
          return Number(cart.item_count) > 0;
        } catch (e) {
          return false;
        }
      }

      /**
       * Unico punto de entrada para abrir el popup. Comprueba las guardas y,
       * si hay un cajon abierto, reintenta mas tarde en vez de taparlo.
       * @param {number} attempt - Reintento actual.
       */
      async requestOpen(attempt = 0) {
        if (this.cancelled || getCookie(this.cookie)) return;

        // 1. Nunca con productos en el carrito: esa visita ya esta comprando.
        if (await PopUp.cartHasItems()) return;

        // 2. Nunca encima de un cajon o modal abierto: esperar a que cierre.
        if (PopUp.overlayOpen()) {
          if (attempt < 40) setTimeout(() => this.requestOpen(attempt + 1), 3000);
          return;
        }

        if (this.cancelled || getCookie(this.cookie)) return;
        this.open();
      }

      /**
       * Triggers when the web component is removed from the DOM
       */
      disconnectedCallback() {
        if (this.mouseLeaveHandler) {
          document.body.removeEventListener('mouseleave', this.mouseLeaveHandler);
        }
      }

      /**
       * Handles 'mouseleave' events on the body.
       * @param {object} evt - Event object.
       */
      handleMouseLeave(evt) {
        if (evt.clientY < 0 && !getCookie(this.cookie)) this.requestOpen();
      }

      /**
       * Handles 'close' events on the modal.
       */
      close() {
        super.close();
        setCookie(this.cookie, true, parseInt(this.dataset.dismissDays, 10));
      }
    }

    customElements.define('pop-up', PopUp);
  });
}
